{
 "source": "InterVA-5 probbase",
 "probbaseVersion": "probbase v19 20210720",
 "count": 353,
 "questions": [
  {
   "id": "i004a",
   "text": "Did s(he) die during the wet season?",
   "short": "d wet",
   "section": "about",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i004b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i004b",
   "text": "Did s(he) die during the dry season?",
   "short": "d dry",
   "section": "about",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i004a",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i019a",
   "text": "Was he male?",
   "short": "male",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i019b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i019b",
   "text": "Was she female?",
   "short": "female",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i022a",
   "text": "Was s(he) aged 65 years or more at death?",
   "short": "65+",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i022b",
   "text": "Was s(he) aged 50 to 64 years at death?",
   "short": "50 to 64",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i022c",
   "text": "Was s(he) aged 15 to 49 years at death?",
   "short": "15 to 49",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i022d",
   "text": "Was s(he) aged 5-14 years at death?",
   "short": "5 to 14",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i022e",
   "text": "Was s(he) aged 1 to 4 years at death?",
   "short": "1 to 4",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i022f",
   "text": "Was s(he) aged 1 to 11 months at death?",
   "short": "1 to 11m",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i022g",
   "text": "Was s(he) aged < 1 month (28 days) at death?",
   "short": "neonate",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i022h",
   "text": "Was s(he) a live baby who died within 24 hours of birth?",
   "short": "d day0",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    },
    {
     "id": "i022k",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i022i",
   "text": "Was s(he) a baby who died between 24 and 48 hours of birth?",
   "short": "d day1",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    },
    {
     "id": "i022k",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i022j",
   "text": "Was s(he) a baby who died more than 48 hours from birth, but within the first week?",
   "short": "d day2-6",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022k",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i022k",
   "text": "Was s(he) a baby who died after the first week, but within the first month?",
   "short": "d wk2-4",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i022l",
   "text": "Was she a woman aged 12-19 years at death?",
   "short": "f 12-19",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i022m",
     "value": "y"
    },
    {
     "id": "i022n",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i022m",
   "text": "Was she a woman aged 20-34 years at death?",
   "short": "f 20-34",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i022l",
     "value": "y"
    },
    {
     "id": "i022n",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i022c",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i022n",
   "text": "Was she a woman aged 35 to 49 years at death?",
   "short": "f 30-49",
   "section": "about",
   "derived": true,
   "dontAskIf": [
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i022m",
     "value": "y"
    },
    {
     "id": "i022l",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i022c",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i059o",
   "text": "Was she married at the time of death?",
   "short": "married",
   "section": "about",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i077o",
   "text": "Did (s)he suffer from any injury or accident that led to her/his death?",
   "short": "injury",
   "section": "injury",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i079o",
   "text": "Was (s)he injured in a road traffic accident?",
   "short": "inj rta",
   "section": "injury",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i082o",
     "value": "y"
    },
    {
     "id": "i084o",
     "value": "y"
    },
    {
     "id": "i086o",
     "value": "y"
    },
    {
     "id": "i090o",
     "value": "y"
    },
    {
     "id": "i091o",
     "value": "y"
    },
    {
     "id": "i093o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i077o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i082o",
   "text": "Was (s)he injured in a non-road transport accident?",
   "short": "inj nrta",
   "section": "injury",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i079o",
     "value": "y"
    },
    {
     "id": "i084o",
     "value": "y"
    },
    {
     "id": "i086o",
     "value": "y"
    },
    {
     "id": "i090o",
     "value": "y"
    },
    {
     "id": "i091o",
     "value": "y"
    },
    {
     "id": "i093o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i077o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i083o",
   "text": "Was (s)he injured in a fall?",
   "short": "inj fall",
   "section": "injury",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i084o",
     "value": "y"
    },
    {
     "id": "i086o",
     "value": "y"
    },
    {
     "id": "i091o",
     "value": "y"
    },
    {
     "id": "i093o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i077o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i084o",
   "text": "Was (s)he poisoned in any way?",
   "short": "inj poison",
   "section": "injury",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i079o",
     "value": "y"
    },
    {
     "id": "i082o",
     "value": "y"
    },
    {
     "id": "i083o",
     "value": "y"
    },
    {
     "id": "i087o",
     "value": "y"
    },
    {
     "id": "i089o",
     "value": "y"
    },
    {
     "id": "i095o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i077o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i085o",
   "text": "Did (s)he die of drowning?",
   "short": "inj drown",
   "section": "injury",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i084o",
     "value": "y"
    },
    {
     "id": "i089o",
     "value": "y"
    },
    {
     "id": "i093o",
     "value": "y"
    },
    {
     "id": "i095o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i077o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i086o",
   "text": "Was (s)he injured by the bite or sting of a venomous animal?",
   "short": "inj venom",
   "section": "injury",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i079o",
     "value": "y"
    },
    {
     "id": "i082o",
     "value": "y"
    },
    {
     "id": "i084o",
     "value": "y"
    },
    {
     "id": "i085o",
     "value": "y"
    },
    {
     "id": "i087o",
     "value": "y"
    },
    {
     "id": "i089o",
     "value": "y"
    },
    {
     "id": "i091o",
     "value": "y"
    },
    {
     "id": "i095o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i077o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i087o",
   "text": "Was (s)he injured by an animal or insect (non-venomous)",
   "short": "inj anim",
   "section": "injury",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i084o",
     "value": "y"
    },
    {
     "id": "i086o",
     "value": "y"
    },
    {
     "id": "i089o",
     "value": "y"
    },
    {
     "id": "i091o",
     "value": "y"
    },
    {
     "id": "i095o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i077o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i089o",
   "text": "Was (s)he injured by burns or fire?",
   "short": "inj burn",
   "section": "injury",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i084o",
     "value": "y"
    },
    {
     "id": "i086o",
     "value": "y"
    },
    {
     "id": "i087o",
     "value": "y"
    },
    {
     "id": "i091o",
     "value": "y"
    },
    {
     "id": "i092o",
     "value": "y"
    },
    {
     "id": "i093o",
     "value": "y"
    },
    {
     "id": "i094o",
     "value": "y"
    },
    {
     "id": "i095o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i077o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i090o",
   "text": "Was (s)he subject to violence (suicide, homicide, abuse)?",
   "short": "inj viol",
   "section": "injury",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i077o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i091o",
   "text": "Was (s)he injured by a fire arm?",
   "short": "inj gun",
   "section": "injury",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i090o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i092o",
   "text": "Was (s)he stabbed, cut or pierced?",
   "short": "inj stab",
   "section": "injury",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i090o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i093o",
   "text": "Was (s)he strangled?",
   "short": "inj strng",
   "section": "injury",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i090o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i094o",
   "text": "Was (s)he injured by a blunt force?",
   "short": "inj blfor",
   "section": "injury",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i090o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i095o",
   "text": "Was (s)he injured by a force of nature?",
   "short": "inj nature",
   "section": "injury",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i084o",
     "value": "y"
    },
    {
     "id": "i086o",
     "value": "y"
    },
    {
     "id": "i087o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i077o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i096o",
   "text": "Was (s)he electrocuted?",
   "short": "inj elec",
   "section": "injury",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i077o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i098o",
   "text": "Was the injury accidental?",
   "short": "inj accid",
   "section": "injury",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i077o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i099o",
   "text": "Was the injury or accident self-inflicted?",
   "short": "inj suic",
   "section": "injury",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i095o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i090o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i100o",
   "text": "Was the injury or accident intentionally inflicted by someone else?",
   "short": "inj int",
   "section": "injury",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i082o",
     "value": "y"
    },
    {
     "id": "i095o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i090o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i104o",
   "text": "Did the baby ever cry?",
   "short": "ever cry",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    },
    {
     "id": "i022k",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i105o",
   "text": "Did the baby cry immediately after birth, even if only a little bit?",
   "short": "cry little",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i104o",
     "value": "n"
    }
   ],
   "askIf": {
    "id": "i104o",
    "value": "y"
   },
   "neonateOnly": true
  },
  {
   "id": "i106a",
   "text": "Was it more than 5 minutes after birth before the baby first cried?",
   "short": "cry 5+m",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i104o",
     "value": "n"
    },
    {
     "id": "i105o",
     "value": "n"
    }
   ],
   "askIf": {
    "id": "i104o",
    "value": "y"
   },
   "neonateOnly": true
  },
  {
   "id": "i107o",
   "text": "Did the baby stop being able to cry?",
   "short": "cry stop",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i104o",
     "value": "n"
    }
   ],
   "askIf": {
    "id": "i104o",
    "value": "y"
   },
   "neonateOnly": true
  },
  {
   "id": "i108a",
   "text": "Did the baby stop crying more than a day before (s)he died?",
   "short": "cry st 1+d",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i104o",
     "value": "n"
    }
   ],
   "askIf": {
    "id": "i107o",
    "value": "y"
   },
   "neonateOnly": true
  },
  {
   "id": "i109o",
   "text": "Did the baby ever move?",
   "short": "ever move",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    },
    {
     "id": "i022k",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i110o",
   "text": "Did the baby ever breathe?",
   "short": "ever breathe",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    },
    {
     "id": "i022k",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i111o",
   "text": "Did the baby breathe immediately after birth, even a little?",
   "short": "brth little",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i110o",
     "value": "n"
    }
   ],
   "askIf": {
    "id": "i110o",
    "value": "y"
   },
   "neonateOnly": true
  },
  {
   "id": "i112o",
   "text": "Did the baby have a breathing problem?",
   "short": "brth prob",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i110o",
     "value": "n"
    }
   ],
   "askIf": {
    "id": "i110o",
    "value": "y"
   },
   "neonateOnly": true
  },
  {
   "id": "i113o",
   "text": "Was the baby given assistance to breathe at birth?",
   "short": "brth assis",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i114o",
   "text": "If the baby didn't show any sign of life, was it born dead?",
   "short": "born dead",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i104o",
     "value": "y"
    },
    {
     "id": "i109o",
     "value": "y"
    },
    {
     "id": "i110o",
     "value": "y"
    },
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    },
    {
     "id": "i022k",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i115o",
   "text": "Were there any bruises or signs of injury on child's body after the birth?",
   "short": "bruised",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i116o",
   "text": "Was the baby's body soft, pulpy and discoloured with the skin peeling away?",
   "short": "macerated",
   "section": "newborn",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    },
    {
     "id": "i022k",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i114o",
    "value": "y"
   },
   "neonateOnly": true
  },
  {
   "id": "i120a",
   "text": "Did the final illness last less than 3 weeks?",
   "short": "ill <3w",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i120b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i120b",
   "text": "Did the final illness last at least 3 weeks?",
   "short": "ill 3+w",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i120a",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i123o",
   "text": "Did (s)he die suddenly?",
   "short": "sudden",
   "section": "history",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i125o",
   "text": "Was there any diagnosis by a health professional of tuberculosis?",
   "short": "dia tb",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i127o",
   "text": "Was there any diagnosis by a health professional of HIV/AIDS?",
   "short": "dia HIV",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i128o",
   "text": "Did (s)he have a recent positive test by a health professional for malaria?",
   "short": "dia mal+",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i129o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i129o",
   "text": "Did (s)he have a recent negative test by a health professional for malaria?",
   "short": "dia mal-",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i128o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i130o",
   "text": "Was there any diagnosis by a health professional of dengue fever?",
   "short": "dia deng",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i131o",
   "text": "Was there any diagnosis by a health professional of measles?",
   "short": "dia meas",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i132o",
   "text": "Was there any diagnosis by a health professional of high blood pressure?",
   "short": "dia hypt",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i133o",
   "text": "Was there any diagnosis by a health professional of heart disease?",
   "short": "dia cvd",
   "section": "history",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i134o",
   "text": "Was there any diagnosis by a health professional of diabetes?",
   "short": "dia diab",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i135o",
   "text": "Was there any diagnosis by a health professional of asthma?",
   "short": "dia asth",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i136o",
   "text": "Was there any diagnosis by a health professional of epilepsy?",
   "short": "dia epil",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i137o",
   "text": "Was there any diagnosis by a health professional of cancer?",
   "short": "dia canc",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i138o",
   "text": "Was there any diagnosis by a health professional of Chronic Obstructive Pulmonary Disease (COPD)?",
   "short": "dia copd",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i139o",
   "text": "Was there any diagnosis by a physician or health worker of dementia?",
   "short": "dia demt",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i140o",
   "text": "Was there any diagnosis by a health professional of depression?",
   "short": "dia depr",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i141o",
   "text": "Was there any diagnosis by a health professional of stroke?",
   "short": "dia strk",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i142o",
   "text": "Was there any diagnosis by a health professional of sickle cell disease?",
   "short": "dia scd",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i143o",
   "text": "Was there any diagnosis by a health professional of kidney disease?",
   "short": "dia kidn",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i144o",
   "text": "Was there any diagnosis by a health professional of liver disease?",
   "short": "dia liver",
   "section": "history",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i147o",
   "text": "During the illness that led to death, did (s)he have a fever?",
   "short": "fever",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i148a",
   "text": "Did the fever last less than a week before death?",
   "short": "fev <1w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i148c",
     "value": "y"
    },
    {
     "id": "i148b",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i147o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i148b",
   "text": "Did the fever last at least one week, but less than 2 weeks before death?",
   "short": "fev 1-2w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i148a",
     "value": "y"
    },
    {
     "id": "i148c",
     "value": "y"
    },
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i147o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i148c",
   "text": "Did the fever last at least 2 weeks before death?",
   "short": "fev 2+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i148a",
     "value": "y"
    },
    {
     "id": "i148b",
     "value": "y"
    },
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i147o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i149o",
   "text": "Did the fever continue until death?",
   "short": "fev death",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i147o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i150a",
   "text": "Was the fever severe?",
   "short": "fev sev",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i147o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i151a",
   "text": "Was the fever continuous?",
   "short": "fev cont",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i147o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i152o",
   "text": "Did (s)he have night sweats?",
   "short": "fev nsw",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i147o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i153o",
   "text": "During the illness that led to death, did (s)he have a cough?",
   "short": "cough",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i154a",
   "text": "Did the cough last less than 3 weeks before death?",
   "short": "cou <3w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i154b",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i153o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i154b",
   "text": "Did the cough last at least 3 weeks before death?",
   "short": "cou 3+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i154a",
     "value": "y"
    },
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i153o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i155o",
   "text": "Was the cough productive, with sputum?",
   "short": "cou prod",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i153o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i156o",
   "text": "Was the cough very severe?",
   "short": "cou sev",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i153o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i157o",
   "text": "Did (s)he cough up blood?",
   "short": "cou bld",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i153o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i158o",
   "text": "Did (s)he make a whooping sound when coughing?",
   "short": "cou whoop",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i153o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i159o",
   "text": "During the illness that led to death, did (s)he have any difficulty breathing?",
   "short": "dif br",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i161a",
   "text": "Did the difficult breathing last for at least 3 days before death?",
   "short": "dif br 3d",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022i",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i159o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i165a",
   "text": "Was the difficult breathing continuous during this period?",
   "short": "dif br con",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i159o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i166o",
   "text": "Did (s)he have fast breathing?",
   "short": "br fast",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i159o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i167a",
   "text": "Did the fast breathing last for less than two weeks before death?",
   "short": "br fs <2w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i167b",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i166o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i167b",
   "text": "Did the fast breathing last for at least 2 weeks before death?",
   "short": "br fs 2+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i167a",
     "value": "y"
    },
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i166o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i168o",
   "text": "Did (s)he have breathlessness?",
   "short": "brless",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i159o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i169a",
   "text": "Did the breathlessness last for less than 2 weeks before death?",
   "short": "brl <2w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i169b",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i168o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i169b",
   "text": "Did the breathlessness last for at least 2 weeks before death?",
   "short": "brl 2+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i169a",
     "value": "y"
    },
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i168o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i170o",
   "text": "Was (s)he unable to carry out daily routines due to breathlessness?",
   "short": "brl unab",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i168o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i171o",
   "text": "Was (s)he breathless while lying flat?",
   "short": "brl flat",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i168o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i172o",
   "text": "Did you see the lower chest wall/ribs being pulled in as the child breathed?",
   "short": "indraw",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i159o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i173a",
   "text": "Did his/her breathing sound like wheezing or grunting?",
   "short": "whz grun",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i159o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i174o",
   "text": "During the illness that led to death, did (s)he have chest pain?",
   "short": "ch pain",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i175o",
   "text": "Was the chest pain severe?",
   "short": "chp sev",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i174o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i176a",
   "text": "Did (s)he experience chest pain at least 3 days before death?",
   "short": "chp 3d",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i174o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i178a",
   "text": "Did the chest pain last for at least 30 minutes?",
   "short": "chp 30m",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i174o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i181o",
   "text": "Did (s)he have diarrhoea?",
   "short": "diarr",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i182a",
   "text": "Did (s)he have diarrhoea for less than 2 weeks before death?",
   "short": "drr <2w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i182c",
     "value": "y"
    },
    {
     "id": "i182b",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i181o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i182b",
   "text": "Did (s)he have diarrhoea for at least 2 weeks but less than 4 weeks before death?",
   "short": "drr 2-4w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i182a",
     "value": "y"
    },
    {
     "id": "i182c",
     "value": "y"
    },
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i181o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i182c",
   "text": "Did (s)he have diarrhoea for at least 4 weeks before death?",
   "short": "drr 4+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i182a",
     "value": "y"
    },
    {
     "id": "i182b",
     "value": "y"
    },
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022i",
     "value": "y"
    },
    {
     "id": "i022j",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i181o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i183a",
   "text": "Did the baby or child have at least 4 stools on the day that loose liquid stools were most frequent?",
   "short": "4+ stls",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i181o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i184a",
   "text": "Did the frequent loose or liquid stools start at least 3 days before death?",
   "short": "drr 3d",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i181o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i185o",
   "text": "Did the frequent loose or liquid stools continue up until death?",
   "short": "drr to d",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i181o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i186o",
   "text": "At any time during the final illness was there blood in the stools?",
   "short": "drr bld",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i181o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i187o",
   "text": "Was there blood in the stool up until death?",
   "short": "dr bld d",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i181o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i188o",
   "text": "During the illness that led to death, did (s)he vomit?",
   "short": "vomit",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i189o",
   "text": "Did (s)he vomit in the week preceding the death?",
   "short": "vom bd",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i188o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i190o",
   "text": "Did (s)he vomit for at least 3 days before death?",
   "short": "vom 3d",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i188o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i191o",
   "text": "Was there blood in the vomit?",
   "short": "vom bld",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i188o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i192o",
   "text": "Was the vomit black?",
   "short": "vom blck",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i188o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i193o",
   "text": "During the illness that led to death, did (s)he have any abdominal (belly) problem?",
   "short": "abdom",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i194o",
   "text": "Did (s)he have abdominal pain?",
   "short": "abd pain",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i193o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i195o",
   "text": "Was the abdominal pain severe?",
   "short": "abd p sev",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i194o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i197a",
   "text": "Did (s)he have severe abdominal pain for less than 2 weeks before death?",
   "short": "abd p <2w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i197b",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i195o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i197b",
   "text": "Did (s)he have severe abdominal pain for at least 2 weeks before death?",
   "short": "abd p 2+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i197a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i195o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i199a",
   "text": "Was the pain in the upper abdomen?",
   "short": "abd p up",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i194o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i199b",
   "text": "Was the pain in the lower abdomen?",
   "short": "abd p lo",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i194o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i200o",
   "text": "Did (s)he have a more than usually protruding abdomen?",
   "short": "abd prot",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i193o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i201a",
   "text": "Did (s)he have a more than usually protruding abdomen for less than 2 weeks before death?",
   "short": "abd pr <2w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i201b",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i200o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i201b",
   "text": "Did (s)he have a more than usually protruding abdomen for at least 2 weeks before death?",
   "short": "abd pr 2+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i201a",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i200o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i203a",
   "text": "Did (s)he develop the protruding abdomen rapidly?",
   "short": "abd pr rap",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i200o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i204o",
   "text": "Did (s)he have any mass in the abdomen?",
   "short": "abd mass",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i193o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i205a",
   "text": "Did (s)he have a mass in the abdomen for less than 2 weeks before death?",
   "short": "ab ms <2w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i205b",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i204o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i205b",
   "text": "Did (s)he have a mass in the abdomen for at least 2 weeks before death?",
   "short": "ab ms 2+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i205a",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i204o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i207o",
   "text": "During the illness that led to death, did (s)he have a severe headache?",
   "short": "headache",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i208o",
   "text": "During the illness that led to death, did (s)he have a stiff neck?",
   "short": "st neck",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i209a",
   "text": "Did (s)he have a stiff neck for less than one week before death?",
   "short": "st n <1w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i209b",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i208o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i209b",
   "text": "Did (s)he have a stiff neck for at least one week before death?",
   "short": "st n 1+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i209a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i208o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i210o",
   "text": "During the illness that led to death, did (s)he have a painful neck?",
   "short": "pain neck",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i211a",
   "text": "Did (s)he have a painful neck for at least one week before death?",
   "short": "pa n 1+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i210o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i212o",
   "text": "During the illness that led to death, did (s)he have mental confusion?",
   "short": "ment conf",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i213o",
   "text": "Did (s)he have mental confusion for at least 3 months before death?",
   "short": "menc 3+m",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i212o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i214o",
   "text": "During the illness that led to death, was (s)he unconscious?",
   "short": "uncons",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i215o",
   "text": "Was (s)he unconscious for at least 24 hours before death?",
   "short": "unc 24+h",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i214o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i216a",
   "text": "Was (s)he unsconscious for at least 6 hours before death?",
   "short": "unc 6+h",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i215o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i217o",
   "text": "Did the unconsciousness start suddenly, quickly (at least within a single day)?",
   "short": "unc sudd",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i215o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i218o",
   "text": "Did the unconsciousness continue until death?",
   "short": "unc to d",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i215o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i219o",
   "text": "During the illness that led to death, did (s)he have any convulsions?",
   "short": "conv",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i220o",
   "text": "Did (s)he experience any generalized convulsions or fits?",
   "short": "conv gen",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i219o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i221a",
   "text": "Did the convulsions last for less than 10 minutes?",
   "short": "conv <10m",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i221b",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i219o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i221b",
   "text": "Did the convulsions last for at least 10 minutes?",
   "short": "conv 10+m",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i221a",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i219o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i222o",
   "text": "Did (s)he become unconscious immediately after the convulsion?",
   "short": "conv unc",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i219o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i223o",
   "text": "During the illness that led to death, did (s)he have any urine problems?",
   "short": "urine",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i224o",
   "text": "Did (s)he stop urinating?",
   "short": "uri none",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i223o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i225o",
   "text": "Did (s)he go to urinate more often than usual?",
   "short": "uri more",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i223o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i226o",
   "text": "Did (s)he pass blood in the urine?",
   "short": "uri bld",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i223o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i227o",
   "text": "During the illness that led to death, did (s)he have any sores or ulcers anywhere?",
   "short": "skin",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i228o",
   "text": "Did (s)he have sores?",
   "short": "sk sores",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i227o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i229o",
   "text": "Did the sores have clear fluid and/or pus?",
   "short": "sk s pus",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i228o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i230o",
   "text": "Did (s)he have an ulcer (pit) on the foot?",
   "short": "sk ul ft",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i227o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i231o",
   "text": "Did any ulcer ooze pus?",
   "short": "sk ul pus",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i227o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i232a",
   "text": "Did the ulcer ooze pus for at least 2 weeks?",
   "short": "sk ul 2+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i231o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i233o",
   "text": "During the illness that led to death, did (s)he have any skin rash?",
   "short": "sk rash",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i234a",
   "text": "Did (s)he have the skin rash for less than one week?",
   "short": "sk ra <1w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i234b",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i233o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i234b",
   "text": "Did (s)he have the skin rash for at least one week?",
   "short": "sk ra 1+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i234a",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i233o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i235a",
   "text": "Did (s)he have a rash on the face?",
   "short": "sk ra face",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i235d",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i233o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i235b",
   "text": "Did (s)he have a rash on the trunk or abdomen?",
   "short": "sk ra abd",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i235d",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i233o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i235c",
   "text": "Did (s)he have a rash on the extremities?",
   "short": "sk ra ext",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i235d",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i233o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i235d",
   "text": "Did (s)he have a rash everywhere?",
   "short": "sk ra all",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i233o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i236o",
   "text": "Did (s)he have measles rash?",
   "short": "sk ra meas",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i237o",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i233o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i237o",
   "text": "Did (s)he ever have shingles or herpes zoster?",
   "short": "sk ra herp",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i236o",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i233o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i238o",
   "text": "During the illness that led to death, did her/his skin flake off in patches?",
   "short": "sk flake",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i233o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i239o",
   "text": "During the illness that led to death, did he/she have areas of the skin that turned black?",
   "short": "sk black",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i233o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i240o",
   "text": "During the illness that led to death, did he/she have areas of the skin with redness and swelling?",
   "short": "sk red",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i233o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i241o",
   "text": "During the illness that led to death, did (s)he bleed from anywhere?",
   "short": "bleed",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i242o",
   "text": "Did (s)he bleed from the nose, mouth or anus?",
   "short": "bld orif",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i241o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i243o",
   "text": "During the illness that led to death, did (s)he have noticeable weight loss?",
   "short": "wt loss",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i244o",
   "text": "Was (s)he severely thin or wasted?",
   "short": "wt waste",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i243o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i245o",
   "text": "During the illness that led to death, did s/he have a whitish rash inside the mouth or on the tongue?",
   "short": "wht rash",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i246o",
   "text": "During the illness that led to death, did (s)he have stiffness of the whole body or was unable to open the mouth?",
   "short": "stiff",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i247o",
   "text": "During the illness that led to death, did (s)he have puffiness of the face?",
   "short": "sw pu face",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i248a",
   "text": "Did (s)he have puffiness of the face for at least one week before death?",
   "short": "sw p f 1+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i247o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i249o",
   "text": "During the illness that led to death, did (s)he have swollen legs or feet?",
   "short": "sw lg ft",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i250a",
   "text": "Did the swelling last for at least 3 days before death?",
   "short": "sw lf 3+d",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i249o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i251o",
   "text": "Did (s)he have both feet swollen?",
   "short": "sw lf bth",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i249o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i252o",
   "text": "During the illness that led to death, did (s)he have general puffiness all over his/her body?",
   "short": "sw puf all",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i253o",
   "text": "During the illness that led to death, did (s)he have any lumps?",
   "short": "lumps",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i254o",
   "text": "Did (s)he have any lumps or lesions in the mouth?",
   "short": "lm mou",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i253o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i255o",
   "text": "Did (s)he have any lumps in the neck?",
   "short": "lm nck",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i253o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i256o",
   "text": "Did (s)he have any lumps in the armpit?",
   "short": "lm arm",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i253o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i257o",
   "text": "Did (s)he have any lumps in the groin?",
   "short": "lm grn",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i253o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i258o",
   "text": "During the illness that led to death, was (s)he in any way paralysed?",
   "short": "paral",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i259o",
   "text": "Did (s)he have paralysis of only one side of the body?",
   "short": "par 1 side",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i258o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i260a",
   "text": "Was only the right side of the body paralysed?",
   "short": "par rs",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i260g",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i260b",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i259o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i260b",
   "text": "Was only the left side of the body paralysed?",
   "short": "par ls",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i260g",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i260a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i259o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i260c",
   "text": "Was only the lower part of the body paralysed?",
   "short": "par lo",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i260d",
     "value": "y"
    },
    {
     "id": "i260g",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i259o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i258o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i260d",
   "text": "Was only the upper part of the body paralysed?",
   "short": "par up",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i260c",
     "value": "y"
    },
    {
     "id": "i260g",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i259o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i258o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i260e",
   "text": "Was only one leg paralysed?",
   "short": "par leg",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i260f",
     "value": "y"
    },
    {
     "id": "i260d",
     "value": "y"
    },
    {
     "id": "i260g",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i258o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i260f",
   "text": "Was only one arm paralysed?",
   "short": "par arm",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i260e",
     "value": "y"
    },
    {
     "id": "i260c",
     "value": "y"
    },
    {
     "id": "i260g",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i258o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i260g",
   "text": "Was the entire body paralysed?",
   "short": "par all",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i260c",
     "value": "y"
    },
    {
     "id": "i260e",
     "value": "y"
    },
    {
     "id": "i260d",
     "value": "y"
    },
    {
     "id": "i260f",
     "value": "y"
    },
    {
     "id": "i260a",
     "value": "y"
    },
    {
     "id": "i260b",
     "value": "y"
    },
    {
     "id": "i259o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i258o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i261o",
   "text": "During the illness that led to death, did (s)he have difficulty swallowing?",
   "short": "swallow",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i262a",
   "text": "Did (s)he have difficulty swallowing for at least one week before death?",
   "short": "swa 1+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i261o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i263a",
   "text": "Did (s)he have difficulty with swallowing solids?",
   "short": "swa sol",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i261o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i263b",
   "text": "Did (s)he have difficulty with swallowing liquids?",
   "short": "swa liq",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i261o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i264o",
   "text": "Did (s)he have pain upon swallowing?",
   "short": "swa pain",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i265o",
   "text": "During the illness that led to death, did (s)he have yellow discolouration of the eyes?",
   "short": "yellow",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i266a",
   "text": "Did (s)he have the yellow discolouration for at least 3 weeks before death?",
   "short": "yell 3+w",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i265o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i267o",
   "text": "During the illness that led to death, did her/his hair change to a reddish or yellowish colour?",
   "short": "hair",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i268o",
   "text": "During the illness that led to death, did (s)he look pale (thinning/lack of blood) or have pale palms, eyes or nail beds?",
   "short": "pale",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i269o",
   "text": "During the illness that led to death, did (s)he have sunken eyes?",
   "short": "eyes sunk",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i270o",
   "text": "During the illness that led to death, did (s)he drink a lot more water than usual?",
   "short": "drink ++",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i271o",
   "text": "Was the baby able to suckle or bottle-feed within the first 24 hours after birth?",
   "short": "suckle",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i272o",
   "text": "Did the baby ever suckle in a normal way?",
   "short": "suck ev",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i271o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i273o",
   "text": "Did the baby stop suckling?",
   "short": "suck st",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i272o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i274a",
   "text": "Did the baby stop suckling on the 2nd day of life or later?",
   "short": "suck st d1+",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i273o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i275o",
   "text": "Did the baby have convulsions starting within the first 24 hours of life?",
   "short": "conv d0",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i276o",
   "text": "Did the baby have convulsions starting more than 24 hours after birth?",
   "short": "conv d1+",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i277o",
   "text": "Did the baby's body become stiff, with the back arched backwards?",
   "short": "stiff",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i278o",
   "text": "During the illness that led to death, did the baby have a bulging or raised fontanelle?",
   "short": "font up",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i279o",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i279o",
   "text": "During the illness that led to death, did the baby have a sunken fontanelle?",
   "short": "font lo",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i278o",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i281o",
   "text": "During the illness that led to death, did the baby become unresponsive or unconscious?",
   "short": "unresp",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i282o",
   "text": "Did the baby become unresponsive or unconscious soon after birth, within less than 24 hours?",
   "short": "unc d0",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i281o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i283o",
   "text": "Did the baby become unresponsive or unconscious more than 24 hours after birth?",
   "short": "unc d1+",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i281o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i284o",
   "text": "During the illness that led to death, did the baby become cold to touch?",
   "short": "cold",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i285a",
   "text": "Was the baby more than 3 days old when it started feeling cold to touch?",
   "short": "cold 3+d",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i284o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i286o",
   "text": "During the illness that led to death, did the baby become lethargic, after a period of normal activity?",
   "short": "lethargy",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022h",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i287o",
   "text": "Did the baby have redness or discharge from the umbilical cord stump?",
   "short": "umbil dis",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i288o",
   "text": "During the illness that led to death, did the baby have skin ulcer(s) or pits?",
   "short": "sk ulcer",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i289o",
   "text": "During the illness that led to death, did the baby have yellow skin, palms (hand) or soles (foot)?",
   "short": "yellow",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i290o",
   "text": "Did the baby or infant appear to be healthy and then just die suddenly?",
   "short": "sudd d",
   "section": "symptoms",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i294o",
   "text": "During the illness that led to death, did she have any swelling or lump in the breast?",
   "short": "sw lm bre",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i295o",
   "text": "During the illness that led to death, did she have any ulcers (pits) in the breast?",
   "short": "sw ul bre",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i296o",
   "text": "Did she ever have a period or menstruate?",
   "short": "menstr",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i297o",
   "text": "During the illness that led to death, did she have excessive vaginal bleeding in between menstrual periods?",
   "short": "men betw",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i296o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i298o",
   "text": "Was the bleeding excessive?",
   "short": "men exc",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i296o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i299o",
   "text": "Did her menstrual period stop naturally because of menopause?",
   "short": "men mpse",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i296o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i300o",
   "text": "Did she have vaginal bleeding after cessation of menstruation?",
   "short": "men mp bl",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i296o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i301o",
   "text": "Was there excessive vaginal bleeding in the week prior to death?",
   "short": "vb <1w",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i296o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i302o",
   "text": "At the time of death was her period overdue?",
   "short": "men late",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i296o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i303a",
   "text": "Had her period been overdue for at least 4 weeks?",
   "short": "men l 4+w",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i302o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i304o",
   "text": "Did she have a sharp pain in her abdomen shortly before death?",
   "short": "obs pain",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i297o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i305o",
   "text": "Was she pregnant (incl. in labour) at the time of death?",
   "short": "pregnant",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i306o",
   "text": "Did she die within 6 weeks of delivery, abortion or miscarriage?",
   "short": "d <6w pend",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i305o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i309o",
   "text": "Was she, or had she been, pregnant for less than 6 months when she died?",
   "short": "d <6m pr",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i305o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i310o",
   "text": "Please confirm: When she died, she was NEITHER pregnant NOR had recently been pregnant NOR had recently delivered when she died - is that right?",
   "short": "not preg",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i312o",
   "text": "Did she die during labour or delivery?",
   "short": "d lab",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i305o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i313o",
   "text": "Did she die after delivering a baby?",
   "short": "d aft del",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i312o",
     "value": "n"
    }
   ],
   "askIf": {
    "id": "i306o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i314o",
   "text": "Did she die within 24 hours after delivery?",
   "short": "d <24h del",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i312o",
     "value": "n"
    }
   ],
   "askIf": {
    "id": "i313o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i315o",
   "text": "Did she die within 6 weeks of childbirth?",
   "short": "d <6w chb",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i312o",
     "value": "n"
    }
   ],
   "askIf": {
    "id": "i313o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i316o",
   "text": "Did she give birth to a live baby (within 6 weeks of her death)?",
   "short": "live baby",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i312o",
     "value": "n"
    }
   ],
   "askIf": {
    "id": "i315o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i317o",
   "text": "Did she die during or after a multiple pregnancy?",
   "short": "mult pr",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i318o",
   "text": "Was she breastfeeding the child in the days before death?",
   "short": "br feed",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i316o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i319a",
   "text": "Did she die during or after her first pregnancy?",
   "short": "1st pr",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i319b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i319b",
   "text": "Did she have four or more pregnancies before this one?",
   "short": "4+ pr",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i319a",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i320o",
   "text": "Had she had any previous Caesarean section?",
   "short": "prev cs",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i319a",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i321o",
   "text": "During pregnancy, did she suffer from high blood pressure?",
   "short": "pr hypt",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i322o",
   "text": "Did she have foul smelling vaginal discharge during pregnancy or after delivery?",
   "short": "pr disch",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i323o",
   "text": "During the last 3 months of pregnancy, did she suffer from convulsions?",
   "short": "pr conv",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i324o",
   "text": "During the last 3 months of pregnancy did she suffer from blurred vision?",
   "short": "pr bl vis",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i325o",
   "text": "Did she have excessive bleeding during pregnancy or shortly after delivery?",
   "short": "pr bleed",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i326o",
   "text": "Was there vaginal bleeding during the first 6 months of pregnancy?",
   "short": "pr bl <6m",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i325o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i327o",
   "text": "Was there vaginal bleeding during the last 3 months of pregnancy but before labour started?",
   "short": "pr bl 6+m",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i325o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i328o",
   "text": "Did she have excessive bleeding during labour, before delivery?",
   "short": "pr bl lab",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i312o",
     "value": "n"
    }
   ],
   "askIf": {
    "id": "i325o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i329o",
   "text": "Did she have excessive bleeding after delivery or abortion?",
   "short": "pr bl ppt",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i312o",
     "value": "n"
    }
   ],
   "askIf": {
    "id": "i325o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i330o",
   "text": "Was the placenta completely delivered?",
   "short": "plnta del",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i312o",
     "value": "n"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i331o",
   "text": "Did she deliver or try to deliver an abnormally positioned baby?",
   "short": "del ab pos",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i312o",
     "value": "n"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i332a",
   "text": "Did her labour last longer than 24 hours?",
   "short": "lab 24+h",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i312o",
     "value": "n"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i333o",
   "text": "Did she attempt to terminate the pregnancy?",
   "short": "term att",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i316o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i334o",
   "text": "Did she recently have a pregnancy that ended in an abortion (spontaneous or induced)?",
   "short": "abort",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i316o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i335o",
   "text": "Did she die during an abortion?",
   "short": "d in abort",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i316o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i336o",
   "text": "Did she die within 6 weeks of having an abortion?",
   "short": "d after ab",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i316o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i335o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i337a",
   "text": "Did the mother deliver at a health facility or clinic?",
   "short": "del hfac",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i313o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i337b",
   "text": "Did the mother deliver at home?",
   "short": "del home",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i337c",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i337a",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i337c",
   "text": "Did the mother deliver elsewhere (not at a health facility nor at home)?",
   "short": "del else",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i337b",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i337a",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i338o",
   "text": "Did she receive professional assistance during the delivery?",
   "short": "del prof",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i313o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i340o",
   "text": "Did she have an operation to remove her uterus shortly before death?",
   "short": "hyster",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i342o",
   "text": "Was the delivery normal vaginal, without forceps or vacuum?",
   "short": "del norm",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i334o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i313o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i343o",
   "text": "Was the delivery vaginal, with forceps or vacuum?",
   "short": "del assist",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i334o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i342o",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i344o",
   "text": "Was the delivery a Caesarean section?",
   "short": "del cs",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i343o",
     "value": "y"
    },
    {
     "id": "i334o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i342o",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i347o",
   "text": "Was her baby born more than one month early?",
   "short": "del >1m ea",
   "section": "women",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i019a",
     "value": "y"
    },
    {
     "id": "i310o",
     "value": "y"
    },
    {
     "id": "i334o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i306o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i354o",
   "text": "Was the child part of a multiple  birth?",
   "short": "mult bir",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i355a",
   "text": "If the child was part of a multiple birth, was it born first?",
   "short": "mult fir",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i354o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i356o",
   "text": "Is the child's mother still alive?",
   "short": "moth aliv",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i357o",
   "text": "Did the child's mother die during or shortly after the delivery?",
   "short": "moth d del",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i356o",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i358a",
   "text": "Did the child's mother die in the baby's first year of life?",
   "short": "moth d y1",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i356o",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i360a",
   "text": "Was the baby born in a health facility or clinic?",
   "short": "born fac",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i360b",
   "text": "Was the baby born at home?",
   "short": "born home",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i360c",
     "value": "y"
    },
    {
     "id": "i360a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i360a",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i360c",
   "text": "Was the baby born somewhere else (e.g. on the way to a clinic)?",
   "short": "born on way",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i360b",
     "value": "y"
    },
    {
     "id": "i360a",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i360a",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i361o",
   "text": "Did the mother receive professional assistance during the delivery?",
   "short": "born prof",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i362o",
   "text": "At birth, was the baby of usual size?",
   "short": "bwt norm",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i363o",
   "text": "At birth, was the baby smaller than normal (weighing under 2.5 kg)?",
   "short": "bwt small",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i365o",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i362o",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i364o",
   "text": "At birth, was the baby very much smaller than usual, (weighing under 1 kg)?",
   "short": "bwt vsmall",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i365o",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i363o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i365o",
   "text": "At birth, was the baby larger than normal (weighing over 4.5 kg)?",
   "short": "bwt big",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i363o",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i362o",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i367a",
   "text": "Was the baby born during the ninth month (at least 37 weeks) of pregnancy?",
   "short": "gest 9m",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i367b",
   "text": "Was the baby born during the eighth month (34 to 37 weeks) of pregnancy?",
   "short": "gest 8m",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i367c",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i367a",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i367c",
   "text": "Was the baby born before the eighth month (less than 34 weeks) of pregnancy?",
   "short": "gest 7m",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i367b",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i367a",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i368o",
   "text": "Were there any complications in the late part of the pregnancy (defined as the last 3 months), but before labour?",
   "short": "cmp bf lab",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i369o",
   "text": "Were there any complications during labour or delivery?",
   "short": "cmp in lab",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i370o",
   "text": "Was any part of the baby physically abnormal at time of delivery? (for example: body part too large or too small, additional growth on body)?",
   "short": "abnorm",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i371o",
   "text": "Did the baby/child have a swelling or defect on the back?",
   "short": "abn back",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i370o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i372o",
   "text": "Did the baby/child have a very large head?",
   "short": "abn lg hd",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i373o",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i370o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i373o",
   "text": "Did the baby/child have a very small head?",
   "short": "abn sm hd",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i372o",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i370o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i376o",
   "text": "Was the baby moving in the last few days before the birth?",
   "short": "bab mov",
   "section": "birth",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i377o",
   "text": "Did the baby stop moving in the womb before labour started?",
   "short": "bab st mov",
   "section": "birth",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i376o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i382a",
   "text": "Did labour and delivery take more than 24 hours?",
   "short": "lab 24+h",
   "section": "birth",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i383o",
   "text": "Was the baby born 24 hours or more after the waters broke?",
   "short": "born 24+h w",
   "section": "birth",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i384o",
   "text": "Was the liquor foul smelling when the waters broke?",
   "short": "liq smell",
   "section": "birth",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i385a",
   "text": "Was the liquor a green or brown colour when the waters broke?",
   "short": "liq gr-br",
   "section": "birth",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i387o",
   "text": "Was the delivery normal vaginal, without forceps or vacuum?",
   "short": "born n del",
   "section": "birth",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i388o",
   "text": "Was the delivery vaginal, with forceps or vacuum?",
   "short": "born as del",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i389o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i387o",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i389o",
   "text": "Was the delivery a Caesarean section?",
   "short": "born cs",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i388o",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i387o",
    "value": "n"
   },
   "neonateOnly": false
  },
  {
   "id": "i391o",
   "text": "Did the child's mother receive any vaccinations since reaching adulthood including during this pregnancy?",
   "short": "moth vacc",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i393o",
   "text": "Did the mother receive tetanus toxoid (TT) vaccine?",
   "short": "moth ttv",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i394a",
   "text": "Was this baby born from the mother's first pregnancy?",
   "short": "born 1st pr",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i394b",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i394b",
   "text": "Did the baby's mother have four or more births before this one?",
   "short": "born 4+ pr",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i394a",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i395o",
   "text": "During labour, did the baby's mother suffer from fever?",
   "short": "moth fev",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i396o",
   "text": "During the last 3 months of pregnancy, labour or delivery, did the baby's mother suffer from high blood pressure?",
   "short": "moth hypt",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i397o",
   "text": "Did the baby's mother have diabetes mellitus?",
   "short": "moth diab",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i398o",
   "text": "Did the baby's mother have foul smelling vaginal discharge during pregnancy or after delivery?",
   "short": "moth disch",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i399o",
   "text": "During the last 3 months of pregnancy, labour or delivery, did the baby's mother suffer from convulsions?",
   "short": "moth conv",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i400o",
   "text": "During the last 3 months of pregnancy did the baby's mother suffer from blurred vision?",
   "short": "moth bl vis",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i401o",
   "text": "Did the baby's mother have severe anaemia?",
   "short": "moth anaem",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i402o",
   "text": "Did the baby's mother have vaginal bleeding during the last 3 months of pregnancy but before labour started?",
   "short": "moth bleed",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i403o",
   "text": "Did the baby's bottom, feet, arm or hand come out of the vagina before its head?",
   "short": "breech",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i404o",
   "text": "Was the umbilical cord wrapped more than once around the baby's neck at birth?",
   "short": "cord wrap",
   "section": "birth",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i405o",
   "text": "Was the umbilical cord delivered first?",
   "short": "cord first",
   "section": "birth",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i406o",
   "text": "Was the baby blue in colour at birth?",
   "short": "born blue",
   "section": "birth",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": true
  },
  {
   "id": "i408o",
   "text": "Before the illness that led to death, was the baby/child growing normally?",
   "short": "grow norm",
   "section": "birth",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i114o",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i411o",
   "text": "Did (s)he drink alcohol?",
   "short": "alco",
   "section": "lifestyle",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i412o",
   "text": "Did (s)he use tobacco?",
   "short": "tobac",
   "section": "lifestyle",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i413o",
   "text": "Did (s)he smoke tobacco (cigarette, cigar, pipe, etc.)?",
   "short": "smoke",
   "section": "lifestyle",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i412o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i414a",
   "text": "Did (s)he use non-smoking tobacco?",
   "short": "tobac ns",
   "section": "lifestyle",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i412o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i415a",
   "text": "Did (s)he smoke at least 10 cigarettes daily?",
   "short": "cigs >10",
   "section": "lifestyle",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    },
    {
     "id": "i022f",
     "value": "y"
    },
    {
     "id": "i022d",
     "value": "y"
    },
    {
     "id": "i022e",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i412o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i418o",
   "text": "Did (s)he receive any treatment for the illness that led to death?",
   "short": "treat",
   "section": "care",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i419o",
   "text": "Did (s)he receive oral rehydration salts?",
   "short": "tr ors",
   "section": "care",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i418o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i420o",
   "text": "Did (s)he receive (or need) intravenous fluids (drip) treatment?",
   "short": "tr drip",
   "section": "care",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i418o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i421o",
   "text": "Did (s)he receive (or need) a blood transfusion?",
   "short": "tr blood",
   "section": "care",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": {
    "id": "i418o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i422o",
   "text": "Did (s)he receive (or need) treatment/food through a tube passed through the nose?",
   "short": "tr ngt",
   "section": "care",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i418o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i423o",
   "text": "Did (s)he receive (or need) injectable antibiotics?",
   "short": "tr inj ab",
   "section": "care",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i418o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i424o",
   "text": "Did (s)he receive (or need) antiretroviral therapy (ART)?",
   "short": "tr art",
   "section": "care",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i418o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i425o",
   "text": "Did (s)he have (or need) an operation for the illness?",
   "short": "tr oper",
   "section": "care",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i418o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i426o",
   "text": "Did (s)he have the operation within 1 month before death?",
   "short": "tr op <1m",
   "section": "care",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i425o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i427o",
   "text": "Was (s)he discharged from hospital very ill?",
   "short": "tr disc ill",
   "section": "care",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i418o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i428o",
   "text": "Did (s)he receive appropriate immunizations?",
   "short": "immun",
   "section": "care",
   "derived": false,
   "dontAskIf": [
    {
     "id": "i022b",
     "value": "y"
    },
    {
     "id": "i022c",
     "value": "y"
    },
    {
     "id": "i022a",
     "value": "y"
    },
    {
     "id": "i022g",
     "value": "y"
    }
   ],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i450o",
   "text": "In the final days before death, did s/he travel to a hospital or health facility?",
   "short": "q trav",
   "section": "circumstances",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i451o",
   "text": "Did (s)he use motorised transport to get to the hospital or health facility?",
   "short": "q trans",
   "section": "circumstances",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i450o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i452o",
   "text": "Were there any problems during admission to the hospital or health facility?",
   "short": "q admit",
   "section": "circumstances",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i450o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i453o",
   "text": "Were there any problems with the way (s)he was treated (medical treatment, procedures, interpersonal attitudes, respect, dignity) in the hospital or health facility?",
   "short": "q treat",
   "section": "circumstances",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i450o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i454o",
   "text": "Were there any problems getting medications, or diagnostic tests in the hospital or health facility?",
   "short": "q meds",
   "section": "circumstances",
   "derived": false,
   "dontAskIf": [],
   "askIf": {
    "id": "i450o",
    "value": "y"
   },
   "neonateOnly": false
  },
  {
   "id": "i455o",
   "text": "Does it take more than 2 hours to get to the nearest hospital or health facility from the deceased's household?",
   "short": "q dist",
   "section": "circumstances",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i456o",
   "text": "In the final days before death, were there any doubts about whether medical care was needed?",
   "short": "q doubt",
   "section": "circumstances",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i457o",
   "text": "In the final days before death, was traditional medicine used?",
   "short": "q tmed",
   "section": "circumstances",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i458o",
   "text": "In the final days before death, did anyone use a telephone or cell phone to call for help?",
   "short": "q phone",
   "section": "circumstances",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  },
  {
   "id": "i459o",
   "text": "Over the course of illness, did the total costs of care and treatment prohibit other household payments?",
   "short": "q costs",
   "section": "circumstances",
   "derived": false,
   "dontAskIf": [],
   "askIf": null,
   "neonateOnly": false
  }
 ]
}